






















































































import mixins from 'vue-typed-mixins'
import OverlayPageModalMixin from '@/mixins/OverlayPageModalMixin'
import ScrollMixin from '@/mixins/ScrollMixin'
import TimelineMixin from '@/mixins/TimelineMixin'
import VirtualScrollMixin from '@/mixins/VirtualScrollMixin'
import AmataBanner from '@/components/AmataBanner.vue'
import AmataTabs from '@/components/AmataTabs.vue'
import AmataTabsItem from '@/components/AmataTabsItem.vue'
import PullRefresh from '@/components/PullRefresh.vue'
import TimelineMedia from '@/components/TimelineMedia.vue'
import Spinner from '@/components/Spinner.vue'
import OverlayPageModal from '@/components/OverlayPageModal.vue'
import TimelineDetail from '@/views/TimelineDetail.vue'
import { sleep, mediaIsSmartPhone } from '@/utils/helpers'
import { loadImage } from '@/utils/ImageUtil'

export default mixins(OverlayPageModalMixin, ScrollMixin, TimelineMixin, VirtualScrollMixin).extend(
  {
    name: 'Timeline',
    components: {
      AmataTabs,
      AmataTabsItem,
      PullRefresh,
      TimelineMedia,
      Spinner,
      OverlayPageModal,
      TimelineDetail
    },
    data() {
      // ここでは computed の値は取得できない
      const storeModuleName = this.$route.name === 'timeline/user' ? 'TimelineUser' : 'Timeline'
      return {
        initialized: false,
        activeTab: this.$store.getters[`${storeModuleName}/type`],
        fetchPayload: {
          url: '/timeline/',
          params: {
            page: 'get_init',
            user_id: this.$route.params.user_id
          }
        },
        isLoading: false,
        refreshing: false,
        chengingActiveTab: false,
        isShowTimeline: true
      }
    },
    watch: {
      async activeTab(index: number) {
        this.chengingActiveTab = true
        window.scrollTo(0, 0)
        this.fetchPayload.params['p'] = 0
        this.fetchPayload.params['type'] = this.tabItems[index].type
        this.$store.commit(`${this.storeModuleName}/setType`, this.tabItems[index].type)
        await this.fetchData()
        await this.$nextTick()
        this.chengingActiveTab = false
      }
    },
    computed: {
      isTimelineUser(): boolean {
        return this.$route.name === 'timeline/user'
      },

      storeModuleName(): string {
        return this.isTimelineUser ? 'TimelineUser' : 'Timeline'
      },

      enabledInfinite(): boolean {
        return this.$store.getters[`${this.storeModuleName}/enabledInfinite`]
      },

      entries(): any[] {
        return this.$store.getters[`${this.storeModuleName}/entries`]
      },

      type(): number {
        return this.$store.getters[`${this.storeModuleName}/type`]
      },

      /**
       * 特定ユーザのタイムラインとしてアクセスしてきた場合はタイトルをニックネームにする
       */
      title(): string {
        return this.isTimelineUser
          ? this.$route.params.name || this.$store.getters['TimelineUser/name']
          : 'タイムライン'
      },

      tabItems(): any[] {
        return this.isTimelineUser
          ? [{ type: 0, label: '新着' }, { type: 4, icon: 'camera' }]
          : [
              { type: 0, label: '新着' },
              { type: 1, icon: 'heart' },
              // {type: 2, label: '検索'},
              { type: 4, icon: 'camera' },
              ...this.manTabItems,
              { type: 3, label: 'My投稿' },
              ...this.womanTabItems
            ]
      },

      manTabItems(): any[] {
        return this.$store.getters['MyData/isMan'] ? [{ type: 5, label: '購入済み' }] : []
      },

      womanTabItems(): any[] {
        return this.$store.getters['MyData/isWoman'] ? [{ type: 6, label: '有料記事' }] : []
      },

      isEmptyEntries(): boolean {
        return this.initialized && this.entries.length === 0
      },

      itemSize(): number {
        return mediaIsSmartPhone ? 180 : 234
      }
    },
    beforeRouteEnter(_to, from, next) {
      next((vm: any) => {
        if (from.name === null || ['timeline', 'timeline/post'].includes(from.name)) {
          vm.fetchData()
        }

        if (from.name === 'timeline/post') {
          if (vm.type === 3 && vm.$refs.amataTabs) {
            // 右端の自分の投稿を表示
            vm.$refs.amataTabs['$el'].scrollLeft = window.innerWidth
          }

          if (from.params.rejected === '1') {
            // リジェクト編集ページからの遷移ならスクロール位置がおかしくなるのでクリア
            vm.isShowTimeline = false
            vm.$nextTick().then(async () => {
              await sleep(100)
              window.scrollTo(0, 0)
              await vm.$nextTick()
              vm.isShowTimeline = true
            })
          }
        }
      })
    },
    async created() {
      if (sessionStorage.getItem('is_blocked') === '1') {
        // だれかをブロックした状態でタイムラインにアクセスしたならブロックを反映するためにリフレッシュ
        if (this.user_id) {
          this.$router.replace('/timeline')
        }
        this.onRefresh()
        sessionStorage.removeItem('is_blocked')
      } else {
        this.fetchPayload.params['type'] = this.type
        if (this.entries.length === 0) {
          await this.fetchData()
        }
      }

      this.$root.$on('routerViewKeyChange', this.resetData)
    },
    async mounted() {
      await this.$nextTick()

      // スクロール位置の復元
      this.$_restoreSavedPosition(this.storeModuleName)

      // window に無限スクロールをセット
      this.$_setHandleScroll(1000, this.handleInfinite)

      await sleep(1000)
      this.initialized = true
    },
    destroyed() {
      this.$root.$off('routerViewKeyChange', this.resetData)
    },
    methods: {
      async fetchData() {
        const data = await this.$store.dispatch(
          `${this.storeModuleName}/getEntries`,
          this.fetchPayload
        )
        if (data) {
          this.$store.commit(`${this.storeModuleName}/setPostPoint`, data.post_point)
          this.$store.commit(`${this.storeModuleName}/setRejectedText`, data.rejected_text)
        }
      },

      async handleInfinite() {
        if (this.isLoading || !this.enabledInfinite) {
          return
        }
        this.isLoading = true
        await this.$store.dispatch(`${this.storeModuleName}/infinite`, {
          fetchPayload: this.fetchPayload
        })
        this.isLoading = false
      },

      /**
       * TimelineMedia をクリック
       */
      handleTimelineMediaClick(data: any, index: string) {
        this.$store.commit('TimelineDetail/setCurrentData', data)
        // TODO: iOS では OverlayPageModal を使用しない
        // if (this.$store.getters.UA_IS_IOS) {
        //   this.$store.commit(`${this.storeModuleName}/setCurrentEntryKey`, index)
        //   this.$router.push(`/timeline/${data.user_id}/${data.t_id}`)
        // } else {
        // $_showOverlayProfileModal 内で自動的に setCurrentEntryKey が 'key' を使ってセットされる
        data.key = index
        data.pushUrl = `#/timeline/${data.user_id}/${data.t_id}`
        data.backUrl = '#/timeline'
        this.$_showOverlayProfileModal(data)
        // }
      },

      /**
       * 特定ユーザのタイムラインを表示しているとき
       */
      async handleBackClick() {
        if (this.$store.getters.fromName === null) {
          this.$router.push('/timeline')
        } else {
          this.$router.back()
        }
      },

      /**
       * アクティブなタブを右にずらす
       */
      handleSwipeLeft() {
        if (this.activeTab === this.tabItems.length - 1) {
          this.activeTab = 0
          return
        }
        this.activeTab += 1
      },

      /**
       * アクティブなタブを左にずらす
       */
      handleSwipeRight() {
        if (this.activeTab === 0) {
          this.activeTab = this.tabItems.length - 1
          return
        }
        this.activeTab -= 1
      },

      /**
       * タイムライン詳細でデータが更新された
       */
      async handleTimelinDetailUpdate(index: number) {
        // TODO: iOS では OverlayPageModal を使用しない
        // if (this.$store.getters.UA_IS_IOS) return

        // OverlayPageModal で開いている場合タイムライン詳細で行った変更が反映されないので
        this.$set(this.entries, index, this.entries[index])
      },

      /**
       * リジェクトされたツイートがクリック
       */
      handleRejectedClick(item: any, index: number) {
        item.index = index
        this.$store.commit(`${this.storeModuleName}/setRejectedEntry`, item)

        this.$router.push({
          name: 'timeline/post',
          params: {
            rejected: '1'
          }
        })
      },

      async onRefresh() {
        this.refreshing = true
        this.fetchPayload.params['p'] = null
        await this.fetchData()
        if (this.$refs.banner) {
          await this.$refs.banner['fetchData']()
        }
        await this.$nextTick()
        this.refreshing = false
      },

      resetData() {
        this.fetchPayload.params['p'] = 0
        this.$store.commit(`${this.storeModuleName}/clearEntries`)
      }
    }
  }
)
